module.exports = __webpack_public_path__ + "img/903.04c1985d.png";